import { jsx as _jsx } from "react/jsx-runtime";
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
export const ROLLBACK_NAV_ITEMS = [
    {
        id: 'tool2-dashboard',
        label: 'Dashboard',
        icon: _jsx(DashboardIcon, {}),
        path: '/tools/tool2/dashboard',
        order: 0
    },
    {
        id: 'tool2-settings',
        label: 'Settings',
        icon: _jsx(SettingsIcon, {}),
        path: '/tools/tool2/settings',
        order: 1
    }
];
